import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import RequireAuth from '@/auth/RequireAuth';
import Login from '@/pages/Login';
import Layout from '@/components/Layout';
import InstanceBanner from '@/components/InstanceBanner';
import Dashboard from '@/pages/Dashboard';
import FlightLog from '@/pages/FlightLog';
import NewFlight from '@/pages/NewFlight';
import FlightDetail from '@/pages/FlightDetail';
import FlightAwareMonitor from '@/pages/FlightAwareMonitor';
import HarassmentAgent from '@/pages/HarassmentAgent';
import Analytics from '@/pages/Analytics';
import Roster from '@/pages/Roster';
import CoOwner from '@/pages/CoOwner';
import History from '@/pages/History';
import Account from '@/pages/Account';

export default function App() {
  return (
    <BrowserRouter>
      <InstanceBanner />
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/flights" element={<FlightLog />} />
            <Route path="/flights/new" element={<NewFlight />} />
            <Route path="/flights/:id" element={<FlightDetail />} />
            <Route path="/flightaware" element={<FlightAwareMonitor />} />
            <Route path="/harassment" element={<HarassmentAgent />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/roster" element={<Roster />} />
            <Route path="/coowner" element={<CoOwner />} />
            {/* The page that tied the log to the Hobbs meter; the balance is gone. */}
            <Route path="/reconcile" element={<Navigate to="/coowner" replace />} />
            <Route path="/history" element={<History />} />
            <Route path="/account" element={<Account />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
